"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Menu_1 = __importDefault(require("@mui/icons-material/Menu"));
const material_1 = require("@mui/material");
const zustandStore_1 = require("../../../../zustandStore");
const SupportHeader = () => {
    const { headerName, openSideMenuOnMobileView } = (0, zustandStore_1.useZustand)(state => ({
        headerName: state.header.headerName,
        openSideMenuOnMobileView: state.openSideMenuOnMobileView,
    }));
    return ((0, jsx_runtime_1.jsx)(material_1.Stack, { className: "main-header", "data-testid": "main-header", style: { zIndex: 0 }, children: (0, jsx_runtime_1.jsxs)(material_1.AppBar, { "ts-variant": "main-header", "data-testid": "main-header", style: { zIndex: 0 }, children: [(0, jsx_runtime_1.jsx)(material_1.Button, { "data-testid": "hamburger-btn", "ts-variant": "hamburger", onClick: () => openSideMenuOnMobileView(true), children: (0, jsx_runtime_1.jsx)(Menu_1.default, { style: { stroke: 'black' } }) }), (0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: headerName, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { "data-testid": "header-overview-title", "ts-variant": "header", children: headerName }) })] }) }));
};
exports.default = SupportHeader;
